var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H23.75V2.5H10C8.61929 2.5 7.5 3.61929 7.5 5V35C7.5 36.3807 8.61929 37.5 10 37.5H30C31.3807 37.5 32.5 36.3807 32.5 35V11.25H35V35C35 37.7614 32.7614 40 30 40H10C7.23858 40 5 37.7614 5 35V5C5 2.23857 7.23858 0 10 0Z",
    fill: "#718096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 7.5V0L35 11.25H27.5C25.4289 11.25 23.75 9.57107 23.75 7.5Z",
    fill: "#718096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 29.5C13 28.6716 13.5223 28 14.1667 28H18.8333C19.4777 28 20 28.6716 20 29.5C20 30.3284 19.4777 31 18.8333 31H14.1667C13.5223 31 13 30.3284 13 29.5Z",
    fill: "#718096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23.5C13 22.6716 13.5223 22 14.1667 22H25.8333C26.4777 22 27 22.6716 27 23.5C27 24.3284 26.4777 25 25.8333 25H14.1667C13.5223 25 13 24.3284 13 23.5Z",
    fill: "#718096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.5C13 16.6716 13.5223 16 14.1667 16H25.8333C26.4777 16 27 16.6716 27 17.5C27 18.3284 26.4777 19 25.8333 19H14.1667C13.5223 19 13 18.3284 13 17.5Z",
    fill: "#718096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFileIcon);
export default __webpack_public_path__ + "static/media/TextFileIcon.be53e81820685aacfcbc8f298b0e2df4.svg";
export { ForwardRef as ReactComponent };